define([
	'internal_util/Util',
	'internal_util/UiUtil',
	'internal_util/ClientUtil',
	'model/ActivationType',
	'state/UIState',
	'service/UIStateManager',
	'service/OptionsManager',
	'service/EventListenerRegistry',
	'view/ProviderInfoView',
	'view/NavigationView',
	'view/ControlView',
	'view/TextView',
	'view/ControlBarView',
	'amdi18n-loader?!state/nls/UIState_strings',
	'amdi18n-loader?!state/nls/IdentitiesRevokationState_strings'
], function (
	Util,
	UiUtil,
	ClientUtil,
	ActivationType,
	UIState,
	UIStateManager,
	OptionsManager,
	EventListenerRegistry,
	ProviderInfoView,
	NavigationView,
	ControlView,
	TextView,
	ControlBarView,
	CommonStrings,
	Strings
) {
	'use strict';

	/**
	 * IdentityCreationState class
	 */
	function IdentityCreationState(uiStateManager) {
		var _uiStateManager,
			_providerInfoView = new ProviderInfoView(),
			_navigationView = new NavigationView(),
			_controlView = new ControlView(authenticationOptionClickHandler),
			_textView = new TextView(),
			_controlBarView = new ControlBarView('skIdS_control-bar-identities-revokation'),
			_authenticationOptions = null,
			_authenticationOptionEidClient = null;

		if (uiStateManager instanceof UIStateManager) {
			_uiStateManager = uiStateManager;
		} else {
			throw new Error('no valid uiStateManager found');
		}

		_navigationView.update(Strings.revokation_of_cloud_identities);

		_textView.get().addClass('skIdS_identities-revokation-information');
		_textView.addText(Strings.information_text);

		_controlBarView.addButton(CommonStrings.back, function () {
			_uiStateManager.back();
		}, 0);

		_controlBarView.addButton(CommonStrings.abort, function () {
			_uiStateManager.abort();
		});

		UIState.call(this, 'identities_revokation');


		// private methods

		function authenticationOptionClickHandler(authenticationOption) {
			_uiStateManager.change('privacy_policy', {
					authenticationOption : authenticationOption,
					requestedAttributes : _uiStateManager.core().cloudIdentitiesManager().requestedAttributes(),
					revokation : true
				});
		}

		function filterAuthenticationOptions(authenticationOptions) {
			
			function filterByEidClient(authenticationOptions){
				var eidClients = _uiStateManager.core().eidClientManager().supportedEidClients(),
					filteredAuthenticationOptions = new Array(),
					i, j;

				for (i = 0; i < authenticationOptions.length; i++) {
					if (authenticationOptions[i].activation() === ActivationType.BROWSER) {
						filteredAuthenticationOptions.push(authenticationOptions[i]);
					} else if (authenticationOptions[i].activation() === ActivationType.EID_CLIENT) {
						for (j = 0; j < eidClients.length; j++) {
							if (eidClients[j].supportsAuthenticationOption(authenticationOptions[i])) {
								filteredAuthenticationOptions.push(authenticationOptions[i]);
								break;
							}
						}
					}
				}
				
				return filteredAuthenticationOptions;
			}
			
			function filterBySession(authenticationOptions) {
				if(_uiStateManager.core().parameters().hasOwnProperty('broker-token')) {
					var options = _uiStateManager.core().optionsManager().authenticationOptions(),
						filteredAuthenticationOptions = new Array(),
						i, j, lastPushed = -1;

					for (i = 0; i < options.length; i++) {
						for (j = 0; j < authenticationOptions.length; j++) {
							var authId = authenticationOptions[j].id();
							var reqAttr = options[i].requestedAttributes();
							
							for (var reqAttAuthOptions in authenticationOptions[j].requestedAttributes()) {
								for (var reqAttOptions in options[i].requestedAttributes()) {
									if (authenticationOptions[j].requestedAttributes()[reqAttAuthOptions].name()
											=== options[i].requestedAttributes()[reqAttOptions].name()) {
										for (var origin in options[i].requestedAttributes()[reqAttOptions].origin()) {
											if (options[i].requestedAttributes()[reqAttOptions].origin()[origin].id()
													=== authId) {
												if (j > lastPushed) {
													authenticationOptions[j].TMP_ReqAttr = reqAttr;
													filteredAuthenticationOptions.push(authenticationOptions[j]);
													lastPushed = j;
													break;
												}
											}
										}
										break;
									}
								}
								
							}
						}
					}
					return filteredAuthenticationOptions;
				} else {
					return authenticationOptions;
				}
			}

			return filterBySession(filterByEidClient(authenticationOptions));
		}

		function eidClientDetectionCycleFinished(eidClients) {
			var authenticationOption,
				handled,
				i, j;

			for (i = 0; i < _authenticationOptions.length; i++) {
				authenticationOption = _authenticationOptions[i];

				if (authenticationOption.activation() !== ActivationType.EID_CLIENT) {
					continue;
				}

				handled = false;

				for (j = 0; j < eidClients.length; j++) {
					if (eidClients[j].supportsAuthenticationOption(authenticationOption)) {
						_controlView.enableAuthenticationOptionCallback(authenticationOption);

						if (!_authenticationOptionEidClient.hasOwnProperty(authenticationOption.id())) {
							if (eidClients[j].supportsStatus()) {
								_controlView.disableAuthenticationOption(authenticationOption);

								_controlView.enableAuthenticationOptionToolTip(authenticationOption,
										authenticationOption.description() + ' ' + Strings.not_available);
							} else {
								_controlView.enableAuthenticationOptionToolTip(authenticationOption,
										authenticationOption.description());
							}
						}

						_authenticationOptionEidClient[authenticationOption.id()] = eidClients[j].id()

						handled = true;
						break;
					}
				}

				if (!handled && _authenticationOptionEidClient.hasOwnProperty(authenticationOption.id())) {
					if (eidClients.length !== 0) {
						_authenticationOptionEidClient[authenticationOption.id()] = null;

						_controlView.disableAuthenticationOption(authenticationOption);
						_controlView.disableAuthenticationOptionCallback(authenticationOption);
						_controlView.enableAuthenticationOptionToolTip(authenticationOption,
								authenticationOption.description() + ' ' + Strings.not_supported);
					} else {
						delete _authenticationOptionEidClient[authenticationOption.id()];

						_controlView.enableAuthenticationOption(authenticationOption);
						_controlView.enableAuthenticationOptionCallback(authenticationOption);
						_controlView.enableAuthenticationOptionToolTip(authenticationOption, authenticationOption.description());
					}
				}
			}
		}

		function cardRecognized(data) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i].activation() !== ActivationType.EID_CLIENT
						|| !_authenticationOptions[i].matchesType(data.card.type())) {
					continue;
				}

				_controlView.enableAuthenticationOption(_authenticationOptions[i]);
				_controlView.enableAuthenticationOptionToolTip(_authenticationOptions[i], _authenticationOptions[i].description());
			}
		}

		function cardRemoved(data) {
			for (var i = 0; i < _authenticationOptions.length; i++) {
				if (_authenticationOptions[i].activation() !== ActivationType.EID_CLIENT
						|| !_authenticationOptions[i].matchesType(data.card.type())) {
					continue;
				}

				_controlView.disableAuthenticationOption(_authenticationOptions[i]);
				_controlView.enableAuthenticationOptionToolTip(_authenticationOptions[i], 
						_authenticationOptions[i].description() + ' ' + Strings.not_available);
			}
		}


		// public methods

		this.title = function () {
			return _uiStateManager.core().cloudIdentitiesManager().providerInfo().description();
		};
		
		this.poweredByImage = function () {
			if (_uiStateManager.core().optionsManager() === null || _uiStateManager.core().optionsManager() === undefined) {
				return null;
			}
			return _uiStateManager.core().optionsManager().providerInfo().poweredByImage();
		};

		this.content = function () {
			return [ _providerInfoView, _navigationView, _textView, _controlView ];
		};

		this.controls = function () {
			return _controlBarView;
		};

		this.enter = function (doneCallback) {
			var cloudIdentitiesManager = _uiStateManager.core().cloudIdentitiesManager();

			if (_uiStateManager.core().contextChangeable()) {
			    _authenticationOptions = filterAuthenticationOptions(cloudIdentitiesManager.getUsableAuthenticationOptions());
			} else {
			    _authenticationOptions = filterAuthenticationOptions(cloudIdentitiesManager.authenticationOptions());
			}
			_authenticationOptionEidClient = new Object();

			if(_uiStateManager.core().contextChangeable()) {
			    _providerInfoView.update(_uiStateManager.core().optionsManager().providerInfo());
			} else {
			    _providerInfoView.update(_uiStateManager.core().cloudIdentitiesManager().providerInfo());
			}
			
			_controlView.update(_authenticationOptions, Strings.no_usable_identity_available);

			EventListenerRegistry.addListener('CARD_RECOGNIZED', cardRecognized);
			EventListenerRegistry.addListener('CARD_REMOVED', cardRemoved);
			EventListenerRegistry.addListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', eidClientDetectionCycleFinished);

			EventListenerRegistry.addOneTimeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', function () {
				Util.callCallbacks(doneCallback);

				UiUtil.scrollTo(_navigationView.get());
			});

			_uiStateManager.core().eidClientManager().startDetection(_authenticationOptions);
		};

		this.leave = function (doneCallback) {
			_uiStateManager.core().eidClientManager().stopDetection(_authenticationOptions);

			EventListenerRegistry.removeListener('EID_CLIENT_DETECTION_CYCLE_FINISHED', eidClientDetectionCycleFinished);
			EventListenerRegistry.removeListener('CARD_RECOGNIZED', cardRecognized);
			EventListenerRegistry.removeListener('CARD_REMOVED', cardRemoved);

			_authenticationOptions = null,
			_authenticationOptionEidClient = null;

			Util.callCallbacks(doneCallback);
		};
	}

	IdentityCreationState.prototype = Object.create(UIState.prototype);

	return IdentityCreationState;
});


//////////////////
// WEBPACK FOOTER
// ./src/main/web/js/app/state/IdentitiesRevokationState.js
// module id = 344
// module chunks = 2